export default __webpack_public_path__ + "static/media/F1_8.a4370898.png";